module.exports = __webpack_public_path__ + "static/media/dispatch-icon.c9dc34a5.svg";